import api, { createAuthenticatedApi } from '../api';

const endpoint = 'allowedmessagetypes';

export const fetchAllowedMessageTypes = async (isXml?: 0 | 1, accessToken?: string): Promise<string[]> => {
    try {
        const apiClient = accessToken ? createAuthenticatedApi(accessToken) : api;
        const params = typeof isXml === 'number' ? { isXml } : {};
        const response = await apiClient.get(`${endpoint}/Get`, { params });
        return response.data;
    } catch (error: any) {
        console.error('Failed to fetch allowed message types from API:', error.message);
        throw new Error('Failed to fetch allowed message types: ' + error.message);
    }
};